module.exports = __webpack_public_path__ + "static/banerENG-a2bc007bc374a3a21769052b72f4bc7c.webp";